import { Theme } from "./theme-interface";

export const theme: Theme = {
  sizeRadioCheckMark: "8px",
  sizeRadio: "20px",
  radioColorsInverted: false,
  sizeCheckbox: "22px",
  borderWidthCheckbox: "2px",
  borderWidthRadio: "2px",

  paddingButton: "12px 32px",
  paddingInput: "8px 12px",
  paddingSelect: "23px 12px 7px 18px",
  paddingSelectLeft: "12px",
  paddingSelectWithFlagLeft: "50px",
  selectChevronTop: "calc(50% - 4px)",
  leftFlag: "14px",
  bottomFlag: "16px",
  pickerLabelAbsolutePosition: true,
  pickerLabelLeft: "14px",
  pickerLabelTop: "8px",
  datePickerMinHeight: "52px",

  borderWidthInput: "2px",
  cardBorder: "1px solid #D9E2E1",

  borderRadiusInput: "5px",
  borderRadiusButton: "4px",
  borderRadiusCheckbox: "4px",
  borderRadiusChecklistCard: "4px",
  borderRadiusPageCard: "0px",
  borderRadiusJourney: "12px",
  borderRadiusBanner: "0px",
  borderRadiusDisclaimer: "0px",
  borderedInput: true,
  backLinkHasChevron: false,
  forwardLinkHasChevron: false,
  linkChevronMargin: "8px",
  linkUnderlined: false,

  mobileBreakingPointNumber: 1110,
  mobileBreakingPoint: "1110px",

  hasDoneMarkOnResolvedCard: true,
  hasStripeOnSuccessBanner: true,
  hasStripeOnErrorBanner: true,
  hasSeparatorsForQuestions: true,

  copyMaxWidth: "75ch",
  containerPadding: "0 16px",

  passportPreviewValueMargin: "4px",

  shadows: {
    card: "none",
    element: "none",
  },
  colors: {
    baseWhite: "#ffffff",
    base1: "#FFFFFF",
    base2: "#F3F9F8",
    base3: "#D9E2E1",
    base4: "#777E7D",
    base5: "#212121",

    primary1: "rgba(0, 24, 113, 1.0)",
    primary2: "rgba(1, 123, 95, 1.0)",
    primary3: "rgba(255, 127, 65, 1.0)",
    primary1opacity40: "rgba(0, 24, 113, 0.4)",
    primary1opacity90: "rgba(0, 24, 113, 0.9)",

    primaryButton: "rgba(0, 24, 113, 1.0)",
    primaryButtonHover: "rgba(0, 24, 113, 0.8)",
    submitButton: "rgba(0, 24, 113, 1.0)",
    submitButtonHover: "rgba(0, 24, 113, 0.8)",
    submitButtonText: "#ffffff",
    outlineButtonHover: "rgba(0, 24, 113, 0.8)",

    errorBanner: "#80206A",

    highlight1: "#FF7F41",
    highlight2: "#F0C450",
    highlight3: "#BF1722",
    highlight4: "#2E7D32",
    disabled1: "rgba(0, 0, 0, 0.25)",
    disabled3: "#E79087",

    alert: "#BF1722",
    confirmation: "#2E7D32",

    additional1: "#395B94",
    activeInput: "#FF7F41",
    activeInputOutline: "rgba(255, 127, 65, 1.0)",
    inactiveRadioButton: "rgba(1, 123, 95, 1.0)",

    journeySectionBackground: "rgba(243, 249, 248, 1.0)",

    cardHighlighter: "rgba(0, 24, 113, 1.0)",

    link: "rgba(1, 123, 95, 1.0)",
    header: "#fff",
    notResolvedChecklistStatus: "rgba(191, 23, 34, 1.0)",
    typographyDefault: "black",
    showMoreLink: "#080206",
  },
  fonts: {
    primaryHeader: {
      family: "Quicksand, sans-serif",
      lineHeight: "125%",
      fontWeight: 600,
      fontSize: "48px",
      letterSpacing: "0.25px",
    },
    secondaryHeader: {
      family: "Quicksand, sans-serif",
      lineHeight: "133%",
      fontWeight: 600,
      fontSize: "36px",
      letterSpacing: "0.25px",
    },
    summary: {
      family: "Quicksand, sans-serif",
      lineHeight: "150%",
      fontWeight: 500,
      fontSize: "20px",
      letterSpacing: "0.25px",
    },
    tertiaryHeader: {
      family: "Quicksand, sans-serif",
      lineHeight: "150%",
      fontWeight: 600,
      fontSize: "28px",
      letterSpacing: "0.25px",
    },
    microHeader: {
      family: "Quicksand, sans-serif",
      lineHeight: "175%",
      fontWeight: 600,
      fontSize: "16px",
      letterSpacing: "0.25px",
    },
    microXSHeader: {
      family: "Quicksand, sans-serif",
      lineHeight: "200%",
      fontWeight: 600,
      fontSize: "12px",
      letterSpacing: "0.25px",
    },
    body: {
      family: "Quicksand, sans-serif",
      lineHeight: "135%",
      fontWeight: 400,
      fontSize: "16px",
      letterSpacing: "0",
    },
    link: {
      family: "Quicksand, sans-serif",
      lineHeight: "135%",
      fontWeight: 400,
      fontSize: "16px",
      letterSpacing: "0",
    },
    smallPrint: {
      family: "Quicksand, sans-serif",
      lineHeight: "12px",
      fontWeight: 600,
      fontSize: "12px",
      letterSpacing: "0",
    },
    button: {
      family: "Quicksand, sans-serif",
      lineHeight: "24px",
      fontWeight: 600,
      fontSize: "16px",
      letterSpacing: "0.4%",
    },
  },
};
